import { useContext } from 'react';
import { HashRouter } from 'react-router-dom';
import { MedalliaFeedback, AuthContext, Header, Footer } from '@chr/navisphereonline-shared-components';
import { LoggingErrorBoundary } from '@chr/common-javascript-logging-error-boundary';
import { SnackbarProvider } from '@chr/eds-react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

import { AppRoutes } from './AppRoutes';
import { GenericErrorPage } from '@/common/components/errors/GenericErrorPage';
import { LicenseInfo } from '@mui/x-license';
export interface AppProps {
  config: AppConfig;
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      suspense: false,
      refetchOnWindowFocus: false,
    },
  },
});

export const App = ({ config }: AppProps) => {
  const authClient = useContext(AuthContext);
  LicenseInfo.setLicenseKey(config.muiDataGridLicenseKey);
  return (
    <>
      <MedalliaFeedback />
      <LoggingErrorBoundary render={GenericErrorPage}>
        <Header />
        <HashRouter>
          <SnackbarProvider>
            <QueryClientProvider client={queryClient}>
              <AppRoutes />
            </QueryClientProvider>
          </SnackbarProvider>
        </HashRouter>
        <Footer />
      </LoggingErrorBoundary>
    </>
  );
};
